'use client';

import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@mui/material';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter';
import InitColorSchemeScript from '@mui/system/InitColorSchemeScript';
import { ReactNode, useEffect, useState } from 'react';

import { getClientSideClient } from '@/lib/ApolloClient';
import { patchConsoleForReactErrors } from '@/lib/reactErrorDecoder';
import theme from '@/theme';

export default function Providers({ children }: { children: ReactNode }) {
  const client = getClientSideClient();
  // Defer color-scheme script until after mount so it doesn't modify <html> before
  // React hydrates (avoids hydration mismatch from MUI script running during parse).
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // Decode React minified errors in console so staging/production show full messages
  useEffect(() => {
    patchConsoleForReactErrors();
  }, []);

  return (
    <AppRouterCacheProvider data-component="Providers">
      <ApolloProvider client={client}>
        {mounted && <InitColorSchemeScript attribute="class" />}
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </ApolloProvider>
    </AppRouterCacheProvider>
  );
}
